// Ícone SVG inline da bandeira Mastercard (sem requisição HTTP)
import * as React from 'react';

export function MastercardIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 48 32" role="img" aria-label="Mastercard" {...props}>
      <rect width="48" height="32" rx="4" fill="#fff" stroke="#E5E7EB" />
      <circle cx="20" cy="16" r="7" fill="#EB001B" />
      <circle cx="28" cy="16" r="7" fill="#F79E1B" />
      <path
        d="M24 10.6a7 7 0 0 0 0 10.8 7 7 0 0 0 0-10.8z"
        fill="#FF5F00"
      />
    </svg>
  );
}
